'use strict';

let analyticsIds = []
let pixelIds = []

let urlParams = window.location.search.substr(1).split('&')
if (urlParams.length > 0) {
  urlParams.forEach(urlParam => {
    let sections = urlParam.split('=')
    if (sections[0] == 'analytics') {
      analyticsIds = sections[1].split(',')
    } else if (sections[0] == 'fbpixel') {
      if(process.env.NODE_ENV !== 'development') pixelIds = sections[1].split(',')
    }
  })
}

let gtagConfig = {}

if (analyticsIds.length) {
  gtagConfig = {
    config: { 
      id: analyticsIds[0],
      params: {
        send_page_view: false
      }
    },
    enabled: process.env.NODE_ENV !== 'development'
  }

  if (analyticsIds.length > 1) {
    let includes = []
    analyticsIds.forEach((id, index) => {
      let include = {
        id: id,
        params: {
          send_page_view: false,
        }
      }
      if(index !== 0) includes.push(include)
    })
    gtagConfig.includes = includes
  }
}

export {
  gtagConfig,
  analyticsIds,
  pixelIds
}